import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import Cuenta from './Cuenta';




interface CuentaTableProps {
  data: Cuenta[];
  columns: TableColumn<Cuenta>[];
  customStyles: Record<string, any>;
}

const CuentaTable: React.FC<CuentaTableProps> = ({ data, columns, customStyles }) => {
  return (
    <DataTable<Cuenta>
      columns={columns}
      data={data}
      pagination
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de'
      }}
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 30]}
      customStyles={customStyles}
      noDataComponent={"No hay registros para mostrar."}
    />
  );
};

export default CuentaTable;